import React from 'react'
import SystemErrorHandler from '../pageBaseComponents/SystemErrorHandler'
import EventEmitterExGuest from '../pageBaseComponents/EventEmitterExGuest'
import {NavigateFunction} from 'react-router-dom'

interface ExternalProps {
    eventEmitter: EventEmitterExGuest
    navigate: NavigateFunction
}

export interface GuestPageProps {
    eventEmitter: EventEmitterExGuest
}

export const withGuestPageTemplate = <OriginalProps extends {}>(
    GuestPageWrappedComponent: React.ComponentType<OriginalProps & GuestPageProps>,
) => {

    type ResultProps = OriginalProps & ExternalProps;

    return class extends React.Component<ResultProps> {
        static displayName: string = `withGuestPageTemplate(${GuestPageWrappedComponent.displayName})`

        render(): JSX.Element {
            return (
                <>
                    <SystemErrorHandler
                        {...this.props}
                        url={'/guest/error'}
                        loginUrl={'/guest/mypage'}
                    />
                    <GuestPageWrappedComponent
                        {...this.props}
                    />
                </>
            )
        }
    }
}
